import { mountComponentTag } from '@/mounter'

import store from '../../../store'
import SurveyModule from './SurveyModule'

mountComponentTag('survey', SurveyModule, {}, false, store)
